import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { register } from "../../services/api";
import { setCookie } from "../../services/cookies";
import { useTranslation } from "react-i18next";
import { Notify } from "notiflix";
import "../../i18n";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [gender, setGender] = useState("");
  const [kvkkConsent, setKvkkConsent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { from, groupId, userId } = location.state || {};

  const { t, i18n } = useTranslation();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!gender) {
      setError("Lütfen cinsiyet seçiniz.");
      return;
    }

    if (!kvkkConsent) {
      setError(t("kvkkConsentRequired"));
      return;
    }

    setLoading(true);
    try {
      console.log(firstname, lastname, username, email, password, gender);
      const response = await register({
        firstname,
        lastname,
        username,
        email,
        password,
        gender,
      });

      if (response && response.user && response.user.id) {
        localStorage.setItem("userId", response.user.id);
      }

      if (response && response.token) {
        setCookie(response.token);
      } else {
        console.log(
          "No token in registration response, user might not be auto-logged in."
        );
      }

      if (from && response && response.token) {
        navigate(from, {
          state: {
            groupId: groupId,
            userId: response.user?.id || userId,
          },
        });
      } else if (response && response.token) {
        navigate("/");
      } else {
        Notify.success("Kayıt başarılı! Lütfen giriş yapın.", {
          distance: "20px",
          timeout: 3000,
          fontSize: "14px",
          borderRadius: "8px",
          position: "right-top",
        });
        navigate("/login");
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Kayıt başarısız. Lütfen bilgilerinizi kontrol edin."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen mx-auto bg-white pl-4 pr-4 lg:pl-0 lg:pr-0 ">
      {/* Sol taraf - Resim */}
      <div className="hidden lg:flex w-[50%] relative h-screen overflow-visible">
        <div className="w-full h-full flex justify-center items-center overflow-visible">
          <div className="relative w-full h-full overflow-visible">
            <div className="w-full h-full rounded-2xl">
              <img
                src="/assets/registerPageImage.png"
                alt="Profil"
                className="object-contain w-full h-full rounded-2xl p-4"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Sağ taraf - Form */}
      <div className="w-full lg:w-[50%] flex flex-col justify-center items-center">
        <div className="w-full max-w-md">
          <div className="flex items-center justify-center gap-2">
            <Link to="/">
              <img
                src="/assets/qriendLogoRedNew.png"
                alt="QRiend Logo"
                className="w-56 h-28"
              />
            </Link>
          </div>
          <h1 className="text-black text-center text-3xl font-semibold mb-2 font-poppins">
            {t("createAccount")}
          </h1>
          <p className="text-[#96A0AD]  text-center text-[14px] font-plus-jakarta-sans font-normal mb-6 font-poppins">
           {t("createAccountDesc")}
          </p>

          {/* Hata mesajı */}
          {error && (
            <div className="mb-4 p-3 bg-red-100 text-red-600 rounded-lg text-sm text-center">
              {error}
            </div>
          )}

          {/* Giriş formu */}
          <form onSubmit={handleSubmit}>
            <div className="flex gap-3 justify-between">
              <div className="mb-3">
                <input
                  type="text"
                  className="text-black w-full p-3 border border-gray-300 rounded-lg font-plus-jakarta-sans text-base bg-white "
                  placeholder={t("firstname")}
                  required
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  className="text-black  w-full p-3 border border-gray-300 rounded-lg font-plus-jakarta-sans text-base bg-white "
                  placeholder={t("lastname")}
                  required
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                />
              </div>
            </div>
            <div className="mb-3">
              <input
                type="text"
                className="text-black  w-full p-3 border border-gray-300 rounded-lg font-plus-jakarta-sans text-base bg-white "
                placeholder={t("username")}
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <input
                type="email"
                className=" text-black  w-full p-3 border border-gray-300 rounded-lg font-plus-jakarta-sans text-base bg-white "
                placeholder={t("email")}
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-4 relative group">
              <select
                className="w-full p-3 border border-gray-300 rounded-lg font-plus-jakarta-sans text-base bg-white appearance-none pr-10 focus:outline-none focus:ring-2 focus:ring-[#E94057] focus:border-transparent transition-all duration-200 hover:border-gray-400 text-gray-500"
                required
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <option value="" disabled className="text-gray-500">
                  {t("gender")}
                </option>
                <option value="MALE">{t("male")}</option>
                <option value="FEMALE">{t("female")}</option>
                <option value="PREFER_NOT_TO_SAY">{t("noGender")}</option>
              </select>
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg
                  className="w-5 h-5 text-gray-400 transition-all duration-200 group-hover:text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            <div className="mb-3">
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password" }
                  className="text-black  w-full p-3 border border-gray-300 rounded-lg font-plus-jakarta-sans text-base bg-white "
                  placeholder={t("password")}
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-gray-500"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-gray-500"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* KVKK Onay Checkbox */}
            <div className="mb-4">
              <label className="flex items-start space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={kvkkConsent}
                  onChange={(e) => setKvkkConsent(e.target.checked)}
                  className="mt-1 h-4 w-4 text-[#E94057] border-gray-300 rounded focus:ring-[#E94057]"
                />
                <span className="text-sm text-gray-700 font-poppins">
                  <Link
                    to="/policies/privacy-policy"
                    className="text-[#E94057] hover:underline"
                    target="_blank"
                  >
                    KVKK ve Gizlilik Sözleşmesini
                  </Link>{" "}
                  onaylıyorum
                </span>
              </label>
            </div>

            <button
              type="submit"
              className="w-full font-poppins bg-gradient-to-r from-[#FA3091] to-[#E94057] text-white p-3 rounded-full font-plus-jakarta-sans text-lg font-semibold pl-4 pr-4 lg:pl-0 lg:pr-0 hover:from-[#E94057] hover:to-[#FA3091] transition-all duration-300 shadow-lg"
              disabled={loading}
            >
              {loading ? "Kayıt Olunuyor..." : t("registerMain")}
            </button>
          </form>

          <p className="text-center mt-4 text-base font-plus-jakarta-sans font-normal pl-4 pr-4 lg:pl-0 lg:pr-0 font-poppins text-black">
            {t("registerDesc")}{" "}
            <Link
              to="/login"
              className="text-[#E94057] text-base font-plus-jakarta-sans font-normal pl-4 pr-4 lg:pl-0 lg:pr-0 font-poppins"
            >
              {t("registerLogin")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
